import React from 'react';
import PropTypes from 'prop-types';
import notifier from '@albert-io/notifier';

class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>> {
  static propTypes = {
    children: PropTypes.node
  };

  state: {
    hasError: boolean;
  };

  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  componentDidCatch(error) {
    // Display fallback UI
    this.setState({hasError: true});
    // Report to error reporting service (this boundary stops React propagation,
    // so no parent boundary will report it for us).
    notifier.notify(error as Error, {
      message: 'WrittenSubmission editor tree threw at render',
      tags: 'free-response'
    });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1>Something went wrong.</h1>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
